module.exports = __webpack_public_path__ + "img/etang_verdure(2)-mobile.7aa568ac.webp";